import React from 'react';

import RequestParameter from 'apps/analytics/components/RequestParameter';
import filterAndMapObject from 'utils/filterAndMapObject';

const ANALYTICS_QUERY_PARAMETERS = {
  fromSearchTerm: 'fromSearchTerm',
};

export function filterAnalyticsParameters(query) {
  return {
    query: filterAndMapObject(query, parameter => ANALYTICS_QUERY_PARAMETERS[parameter] === undefined),
    analyticParameters: filterAndMapObject(query, parameter => ANALYTICS_QUERY_PARAMETERS[parameter] !== undefined),
  };
}

export function trackRequestParameters(location) {
  const { query } = location;
  const queryWithNoAnalyticParams = filterAnalyticsParameters(query).query;
  return queryWithNoAnalyticParams
    ? Object.keys(queryWithNoAnalyticParams).map((parameter, index) => (
      <RequestParameter
        parameter={parameter}
        value={query[parameter]}
        key={`req_param_${parameter}_${index}`} // eslint-disable-line react/no-array-index-key
      />
    ))
    : null;
}
